import { useEffect } from "react";
import { useToolkitIdeasRuntime } from "src/pods/ideas/useToolkitIdeasRuntime";
import { useToolkitGroupsRuntime } from "src/pods/groups/useToolkitGroupsRuntime";
import { installToolkitNativeBridge, subscribeNativeActions } from "./toolkitNativeBridge";
import { useToolkitListRuntime } from "src/pods/list/useToolkitListRuntime";
import { useToolkitNoiseRuntime } from "src/pods/noise/useToolkitNoiseRuntime";
import { useToolkitPairshareRuntime } from "src/pods/pairshare/useToolkitPairshareRuntime";
import { useToolkitRadioRuntime } from "src/pods/radio/useToolkitRadioRuntime";
import { useToolkitRandomRuntime } from "src/pods/random/useToolkitRandomRuntime";
import { useRealtimeRuntime } from "src/pods/realtime/useRealtimeRuntime";
import { toolkitActions } from "./toolkitStore";
import { handleToolkitWebviewAction, useToolkitWebviewRuntime } from "src/pods/webviewInit";
import { useToolkitTimerRuntime } from "src/pods/timer/useToolkitTimerRuntime";
import { useToolkitTodayRuntime } from "src/pods/today/useToolkitTodayRuntime";
import { dispatchToolkitReduxAction } from "./toolkitReduxStore";

export default function ToolkitRuntime() {
  useToolkitIdeasRuntime();
  useToolkitGroupsRuntime();
  useToolkitListRuntime();
  useToolkitNoiseRuntime();
  useToolkitPairshareRuntime();
  useToolkitRadioRuntime();
  useToolkitRandomRuntime();
  useToolkitTimerRuntime();
  useToolkitTodayRuntime();
  useToolkitWebviewRuntime();
  useRealtimeRuntime();

  useEffect(() => {
    installToolkitNativeBridge();
    toolkitActions.setRuntimeReady(true);

    const unsubscribe = subscribeNativeActions((action) => {
      if (handleToolkitWebviewAction(action)) {
        return;
      }

      dispatchToolkitReduxAction(action);
    });

    return () => {
      unsubscribe();
      toolkitActions.setRuntimeReady(false);
    };
  }, []);

  return null;
}
